import { Typography } from '@mui/material';
import React from 'react';

export function NotFound() {
  return <Typography variant="h1">NotFound</Typography>;
}
